class Header {
  // Constructor
  constructor() {
    if (document.querySelector('.wp-block-kadence-user-info')) {
      this.userInfoBlock = document.querySelector(
        `.wp-block-kadence-user-info`
      );
      this.selectedElement = document.querySelector('.pf-user-nav .sub-menu');

      this.events();
    }
  }

  // Events
  events() {
    this.userInfoBlock.addEventListener('mouseenter', (e) => {
      this.selectedElement.style.opacity = '1';
      this.selectedElement.style.visibility = 'visible';
      this.selectedElement.style.clip = 'auto';
      this.selectedElement.style.height = 'auto';
    });

    this.userInfoBlock.addEventListener('mouseleave', (e) => {
      this.selectedElement.style.removeProperty('opacity');
      this.selectedElement.style.removeProperty('visibility');
      this.selectedElement.style.removeProperty('clip');
      this.selectedElement.style.removeProperty('height');
    });
  }

  // Methods
}

export default Header;
